interface EventProperties {
  [key: string]: any;
}

class Analytics {
  private static instance: Analytics;
  private initialized = false;
  private queue: Array<{
    type: 'track' | 'page' | 'identify' | 'group';
    event: string;
    properties?: EventProperties;
  }> = [];

  private constructor() {
    this.processQueue = this.processQueue.bind(this);
    this.initialize();
  }

  static getInstance(): Analytics {
    if (!Analytics.instance) {
      Analytics.instance = new Analytics();
    }
    return Analytics.instance;
  }

  private async initialize() {
    if (this.initialized) return;

    try {
      // Here you would initialize your analytics service
      this.initialized = true;
      await this.processQueue();
    } catch (error) {
      console.error('Failed to initialize analytics:', error);
    }
  }

  private async processQueue() {
    if (!this.initialized || this.queue.length === 0) return;

    const events = [...this.queue];
    this.queue = [];

    for (const event of events) {
      try {
        switch (event.type) {
          case 'track':
            console.log('Track:', event.event, event.properties);
            break;
          case 'page':
            console.log('Page:', event.event, event.properties);
            break;
          case 'identify':
            console.log('Identify:', event.event, event.properties);
            break;
          case 'group':
            console.log('Group:', event.event, event.properties);
            break;
        }
      } catch (error) {
        console.error(`Failed to process ${event.type} event:`, error);
        this.queue.push(event); // Re-queue failed events
      }
    }
  }

  track(eventName: string, properties?: EventProperties) {
    this.queue.push({
      type: 'track',
      event: eventName,
      properties,
    });
    this.processQueue();
  }

  page(pageName: string, properties?: EventProperties) {
    this.queue.push({
      type: 'page',
      event: pageName,
      properties,
    });
    this.processQueue();
  }

  identify(userId: string, traits?: EventProperties) {
    this.queue.push({
      type: 'identify',
      event: userId,
      properties: traits,
    });
    this.processQueue();
  }

  group(groupId: string, traits?: EventProperties) {
    this.queue.push({
      type: 'group',
      event: groupId,
      properties: traits,
    });
    this.processQueue();
  }
}

export const analytics = Analytics.getInstance();
